<template>
  <el-dialog v-model="show" :show-close="false" :close-on-press-escape="false" :width="'678px'" :custom-class="'dialog-no-title dialog-full-transparent'" :close-on-click-modal="false" lock-scroll>
    <div class="interest-select-window">
      <p class="p-0">选择感兴趣的研究领域</p>
      <p class="p-1">我们将根据您选择的研究领域为您推荐相关信息</p>
      <div class="options" v-loading="loading">
        <div v-for="(item,index) in selections" :key="item.id" class="option" :class="{'active': item.selected }" @click="selectByIndex(index)">
          {{ item.val }}
        </div>
      </div>
      <p class="confirm" @click="confirm" v-loading="btnLoading">选好了</p>
      <!-- <img src="@/assets/images/Tan/pop/interest/close.png" class="close" @click="close"/> -->
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { getSelectFatherSonByType } from "@/api/config";
import { ElMessage } from "element-plus";
import { editTanResearch } from "@/api/Tan/company";
import { getTanMemberInfo } from "@/api/Tan/member";
import { getTanId,getTanLocalInfo } from "@/utils/Tan/login";

export default{
  data(){
    return{
      show: false,
      selections: [],
      loading: false,
      btnLoading: false,
    }
  },
  computed:{
    ...mapGetters([
      "TanInterestSelectPopShow",
      "TanTicketReceivePopShow",
    ]),
    selectedValue(){
      return this.selections.filter(item=>item.selected)?.map((item)=>item.val) || []
    },
    selectedNum(){
      return this.selectedValue?.length || 0
    },
  },
  watch:{
    TanInterestSelectPopShow(val){
      this.show = val
      if(val){
        this.getSelections()
      }
      else{
        this.selections = this.selections.map(item=>{
          item.selected = false
          return item
        })
      }
    },
    TanTicketReceivePopShow(val){
      // * 初次登陆，在领取使用优惠券之后，判断打开弹窗
      if(val) return
      const tjInfo = getTanLocalInfo().tjInfo
      if(tjInfo && tjInfo.researchFieldList && tjInfo.researchFieldList.length === 0){
        setTimeout(()=>{
          this.$store.dispatch('Tan/setInterestSelectPopShow',true)
        },500)
      }
    }
  },
  methods:{
    selectByIndex(index){
      if(this.selectedNum === 10 && !this.selections[index].selected){
        ElMessage.warning('最多选择10个')
        return
      }
      this.selections[index].selected = !this.selections[index].selected
    },
    getSelections(){
      this.loading = true
      getSelectFatherSonByType(10037).then(res=>{
        this.selections = res.data.map((item)=>{
          return {
            ...item,
            selected: false,
          }
        })
      }).finally(()=>{
        this.loading = false
      })
    },
    confirm(){
      if(this.selectedNum === 0){
        ElMessage.warning('请选择您感兴趣的研究领域！')
        return
      }
      this.btnLoading = true
      editTanResearch(this.selectedValue).then(()=>{
        ElMessage.success('选择成功')
        this.close()
        getTanMemberInfo(getTanId())  // * 通过接口存入缓存
      }).finally(()=>{
        this.btnLoading = false
      })
    },
    close(){
      this.$store.dispatch('Tan/setInterestSelectPopShow',false)
    },
  },
}
</script>

<style scoped lang="scss">
.interest-select-window{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 46px;
  background-color: #FFFFFF;
  border-radius: 10px;
  padding-bottom: 51px;
  .p-0{
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 25px;
    padding-bottom: 6px;
  }
  .p-1{
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #394147;
    line-height: 20px;
    padding-bottom: 35px;
  }
  .options{
    width: 570px;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 34px;
    min-height: 244px;
    box-sizing: border-box;
  }
  .option{
    width: 100px;
    height: 32px;
    background: #F4F7FC;
    border-radius: 4px;
    margin: 0px 7px 10px;
    cursor: pointer;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 32px;
    box-sizing: border-box;
    border: 1px solid #F4F7FC;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    padding: 0 4px;
  }
  .active{
    position: relative;
    border: 1px solid $--color-theme !important;
    &::after{
      content: "";
      width: 12px;
      height: 12px;
      position: absolute;
      right: 4px;
      top: 4px;
      background-image: url('../../../assets/images/Tan/pop/interest/choosed.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .confirm{
    width: 172px;
    height: 32px;
    background: $--color-theme;
    border-radius: 3px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 32px;
    cursor: pointer;
    text-align: center;
  }
}
</style>